<div class="container login">
    <div class="row">
        <div class="col-md-12">
            <div class="box mt40 mb40 static">
                <div class="row">
                    <div class="col-md-6">
                        <div class="contact-address-widget">
                            <h1>İletişim</h1>
                            <p class="lh-20">
                                CAR DATA INTERNATIONAL - CDI Otomotiv Bilgi Hizmetleri Anonim Şirketi
                            </p>
                            <p style="font-weight: bold; font-size: 15px;">
                                Genel Müdürlük<br />
                            </p>
                            <p style="font-size: 15px;">
                                <span class="contact-title">Adres</span>
                                Koşuyolu Mh. Halili Sk. No:9/2 34718 Kadıköy / İstanbul
                            </p>
                            <p style="font-size: 15px;">
                                <span class="contact-title">Telefon</span>
                                +90 (216) 969 11 91 (pbx)
                            </p>
                            <p style="font-size: 15px;">
                                <span class="contact-title">Fax</span>
                                +90 (216) 969 11 97
                            </p>
                            <p style="font-size: 15px;">
                                <span class="contact-title">E-Posta</span>
                                <a href="mailto:info@cardata.com.tr" target="_blank">info@cardata.com.tr</a>
                            </p>
                            <p style="padding-top:15px;">
                                <img src="../../../assets/img/shared/e-SIRKET.png" />
                            <table>
                                <tr>
                                    <td>Ticari Unvan</td>
                                    <td style="padding-left: 10px;">:</td>
                                    <td style="padding-left: 10px;">CDI Otomotiv Bilgi Hizmetleri Anonim Şirketi</td>
                                </tr>
                                <tr>
                                    <td>Kuruluş Tarihi</td>
                                    <td style="padding-left: 10px;">:</td>
                                    <td style="padding-left: 10px;">2012</td>
                                </tr>
                                <tr>
                                    <td>Vergi Dairesi</td>
                                    <td style="padding-left: 10px;">:</td>
                                    <td style="padding-left: 10px;">Kadıköy</td>
                                </tr>
                                <tr>
                                    <td>Vergi No</td>
                                    <td style="padding-left: 10px;">:</td>
                                    <td style="padding-left: 10px;">203 031 12 54</td>
                                </tr>
                                <tr>
                                    <td>Ticaret Sicil Müd.</td>
                                    <td style="padding-left: 10px;">:</td>
                                    <td style="padding-left: 10px;">İstanbul</td>
                                </tr>
                                <tr>
                                    <td>Ticaret Sicil No</td>
                                    <td style="padding-left: 10px;">:</td>
                                    <td style="padding-left: 10px;">828237</td>
                                </tr>
                                <tr>
                                    <td>Mersis No</td>
                                    <td style="padding-left: 10px;">:</td>
                                    <td style="padding-left: 10px;">0203031125400012</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="col-md-6" *ngIf="!formValid">
                        <form [formGroup]="contactForm">
                            <div class="contact-widget">
                                <div class="form-group">
                                    <input class="contact-input" placeholder="Şirket" type="text"
                                        formControlName="company">
                                </div>
                                <div class="form-group">
                                    <input class="contact-input" placeholder="Ad Soyad (*)" type="text"
                                        formControlName="name">
                                    <div class="text-danger" *ngIf="!nameValid">
                                        Ad Soyad bilgilerini kontrol ediniz.
                                    </div>
                                </div>
                                <div class="form-group">
                                    <input class="contact-input" type="email" placeholder="E-Posta (*)"
                                        formControlName="email">
                                    <div class="text-danger" *ngIf="!mailValid">
                                        Eposta adresini kontrol ediniz.
                                    </div>
                                </div>
                                <div class="form-group">
                                    <input class="contact-input" placeholder="Telefon (*)" prefix="+90"
                                        mask="(000) 000 00 00" formControlName="phone" (ngModelChange)="checkPhone()">
                                    <div class="text-danger" *ngIf="!phoneValid">
                                        Telefon numarasını kontrol ediniz.
                                    </div>
                                </div>
                                <div class="form-group">
                                    <textarea required placeholder="Mesaj (*)" data-rule-required="true" id="Message"
                                        name="Message" formControlName="message"></textarea>
                                    <div class="text-danger" *ngIf="!messageValid">
                                        Mesajınızı kontrol ediniz.
                                    </div>
                                </div>

                                <button formmethod="post" class="btn btn-primary btn-l" (click)="onSubmit()"
                                    *ngIf="!formValid">Gönder</button>
                            </div>
                        </form>
                        <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
                    </div>
                    <div class="col-md-6" *ngIf="formValid">
                        <div class="contact-success-card">
                            <div class="contact-success-icon">✓</div>
                            <h2 class="contact-success-title">Mesajınız Bize Ulaştı!</h2>
                            <p class="contact-success-desc">En kısa sürede sizinle iletişime geçeceğiz.</p>
                            <table class="table table-bordered contact-success-table">
                                <tbody>
                                    <tr>
                                        <td><b>Şirket</b></td>
                                        <td>{{this.contactForm.value.company}}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Ad Soyad</b></td>
                                        <td>{{this.contactForm.value.name}}</td>
                                    </tr>
                                    <tr>
                                        <td><b>E-posta</b></td>
                                        <td>{{this.contactForm.value.email}}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Telefon</b></td>
                                        <td>{{this.contactForm.value.phone}}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Mesaj</b></td>
                                        <td>{{this.contactForm.value.message}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box mb40">
                <div class="row">
                    <div class="col-md-12">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12042.681035799433!2d29.0371582!3d41.0105899!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xed5dfc405c8ca93d!2sCARDATA!5e0!3m2!1str!2str!4v1594655635889!5m2!1str!2str"
                            width="100%" height="400" frameborder="0" style="border:0;" allowfullscreen=""
                            aria-hidden="false" tabindex="0"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>